import { api } from "@/lib/api";

export const PROJECT_TYPE_META = {
  music_news:          { label: "Music News",         emoji: "🎵", hint: "Latest releases, charts, artist updates" },
  entertainment_news:  { label: "Entertainment News", emoji: "✨", hint: "Pop culture, awards, drama" },
  artist_spotlight:    { label: "Artist Spotlight",   emoji: "🎤", hint: "Bio, hits, career timeline" },
  album_review:        { label: "Album Review",       emoji: "💿", hint: "Track-by-track or top-line review" },
  podcast_video:       { label: "Podcast Video",      emoji: "🎙️", hint: "Waveform + motion graphics over audio" },
  video_podcast:       { label: "Video Podcast",      emoji: "📹", hint: "Multi-cam style with lower thirds" },
  concert_promotion:   { label: "Concert Promotion",  emoji: "🎟️", hint: "Event hype reel" },
  station_promo:       { label: "Station Promo",      emoji: "📡", hint: "Brand spot for your radio station" },
  event_promotion:     { label: "Event Promotion",    emoji: "🎉", hint: "Generic event hype reel" },
  commercial:          { label: "Commercial",         emoji: "💼", hint: "15s/30s sponsor or sponsored content" },
  social_media_video:  { label: "Social Media Video", emoji: "📱", hint: "Optimized for Reels / TikTok / Shorts" },
  youtube_video:       { label: "YouTube Video",      emoji: "📺", hint: "Long-form 5-10 min YouTube format" },
  documentary:         { label: "Documentary",        emoji: "🎬", hint: "Long-form storytelling" },
  educational_video:   { label: "Educational Video",  emoji: "🎓", hint: "Tutorial / explainer format" },
  cartoon_project:     { label: "Cartoon Project",    emoji: "🦊", hint: "Animated style direction" },
  custom_project:      { label: "Custom Project",     emoji: "🪄", hint: "Define your own brief" },
};

export const STATUS_META = {
  draft:         { label: "Draft",         color: "text-ink-muted",    bg: "bg-bg-elevated" },
  scripted:      { label: "Scripted",      color: "text-brand-blue",   bg: "bg-brand-blue/10" },
  storyboarded: { label: "Storyboarded",  color: "text-brand-amber",  bg: "bg-brand-amber/10" },
  voiced:        { label: "Voiced",        color: "text-emerald-300",  bg: "bg-emerald-500/10" },
  rendering:     { label: "Rendering",     color: "text-violet-300",   bg: "bg-violet-500/10" },
  ready:         { label: "Ready",         color: "text-emerald-300",  bg: "bg-emerald-500/15" },
  published:     { label: "Published",     color: "text-emerald-300",  bg: "bg-emerald-500/15" },
};

export const visionApi = {
  access:        () => api.get("/vision/access").then(r => r.data),
  providers:     () => api.get("/vision/providers").then(r => r.data),
  listProjects:  () => api.get("/vision/projects").then(r => r.data),
  getProject:    (id) => api.get(`/vision/projects/${id}`).then(r => r.data),
  createProject: (body) => api.post("/vision/projects", body).then(r => r.data),
  updateProject: (id, body) => api.patch(`/vision/projects/${id}`, body).then(r => r.data),
  deleteProject: (id) => api.delete(`/vision/projects/${id}`).then(r => r.data),
  genScript:     (id) => api.post(`/vision/projects/${id}/script`).then(r => r.data),
  genStoryboard: (id, brand) => api.post(`/vision/projects/${id}/storyboard`, { brand_keywords: brand || "" }).then(r => r.data),
  connectProvider:    (key, body) => api.post(`/vision/providers/${key}/connect`, body).then(r => r.data),
  disconnectProvider: (key) => api.post(`/vision/providers/${key}/disconnect`).then(r => r.data),
};
